import React from "react";
import { Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { GlobalSpinner, previewVoucher } from '../../../../../global/globalFunctions'
import MaterialTable from 'material-table';
import PrintIcon from '@mui/icons-material/Print';
import moment from "moment";


const VoucherSearchDetails = (props) => {
    return (
        <>
            {props.isFetchingSearchVoucher ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <div className="sendDiv">
                        <Link to="/accountsModule/Voucher/VoucherSearch">
                            <Button><b>BACK TO SEARCH </b></Button>
                        </Link>
                    </div>

                    <MaterialTable
                        title="Voucher Search"
                        columns={[
                            {
                                title: "Serial No", field: "sequenceNumber",
                                cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                            },
                            {
                                title: "Voucher ID", field: "voucherManualId",
                                cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                            },
                            {
                                title: "Voucher Date",
                                field: "vocDate",
                                render: (rowData) => {
                                    const voucherDate = rowData.vocDate;
                                    const createdTime = moment(rowData.createdAt).format('LT');
                                    return `${voucherDate} ${createdTime}`;
                                }
                            },
                            {
                                title: "Status",
                                field: "status",
                                render: (rowData) => (
                                    <div
                                        style={{
                                            backgroundColor: rowData.status === "Approved" ? "#9FD983" : rowData.status === "Pending" ? "#f7cb74" : rowData.status === "Disapproved" ? "#F8B8A2" : "#f7cb74",
                                            padding: "5px 16px 7px",
                                            borderRadius: "10px",
                                            textAlign: "center",
                                            width: "max-content"
                                        }}
                                    >
                                        {rowData.status}
                                    </div>
                                ),
                            },
                            { title: "Created By", field: "userDetails.userName" },
                            { title: "Approved By", field: "approvelUser.userName" },
                            { title: "Approved Date", field: "voucherApprovelDate" },
                        ]}
                        data={props.searchVoucherList}
                        detailPanel={rowData => {
                            return (
                                <MaterialTable
                                    title="Vocuher Details"
                                    columns={[
                                        { title: "Account Title", field: "accountTittle" },
                                        { title: "Bill No", field: "billNumber" },
                                        { title: "Voucher Description", field: "voucherDescription" },
                                        { title: "Amount", field: "voucherAmount", render: rowData => `${rowData.voucherAmount.toLocaleString()}/-` },
                                        { title: 'Cheque No', field: 'chequeNo' },
                                        { title: 'Cheque Date', field: 'chequeDate' },
                                        { title: "Account Type", field: "accountType", render: rowData => rowData.accountType === 1 ? "Credit" : rowData.accountType === 2 ? "Debit" : "" }
                                    ]}
                                    data={rowData.voucherData}
                                    options={{
                                        toolbar: false,
                                        search: false,
                                        actionsColumnIndex: -1,
                                        exportButton: false,
                                        exportAllData: false,
                                        paging: false,
                                        pageSize: 50,
                                        emptyRowsWhenPaging: false,
                                        pageSizeOptions: [50, 100, 150, 200],
                                        headerStyle: {
                                            position: "sticky",
                                            top: 0,
                                            color: "#00BBBB",
                                            fontWeight: "550",
                                            fontSize: "14px",
                                        },
                                        rowStyle: (rowData, index) => ({
                                            backgroundColor: "#ededed",
                                            // fontWeight: rowData.accountType === 1 ? "bold" : "normal",
                                            color: "black"
                                        }),
                                    }}
                                />
                            )
                        }}
                        actions={[
                            (rowData) => ({
                                icon: () => <PrintIcon style={{ color: '#1D1D1D' }} />,
                                tooltip: "Print Voucher",
                                onClick: (event, rowData) => {
                                    previewVoucher(rowData, rowData.status);
                                },
                            }),
                        ]}
                        options={{
                            actionsColumnIndex: -1,
                            exportButton: true,
                            exportAllData: true,
                            paging: true,
                            filtering: false,
                            pageSize: 50,
                            emptyRowsWhenPaging: false,
                            pageSizeOptions: [50, 100, 150, 200],
                            headerStyle: {
                                position: "sticky",
                                top: 0,
                                color: "#00BBBB",
                                fontWeight: "550",
                                onRowAdd: "none",
                            },
                        }}
                    />

                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {

    };
};

const mapStateToProps = (state, ownProps) => ({
    isFetchingSearchVoucher: state.VouchersReducer.isFetchingSearchVoucher,
    searchVoucherList: state.VouchersReducer.searchVoucherList,
});

export default connect(mapStateToProps, mapDispatchToProps)(VoucherSearchDetails);